import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';
import { ModalUploadNfService } from './modal-upload-nf.service';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
//import { UploadFile, UploadInput, UploadOutput } from 'ng-uikit-pro-standard';
//import { humanizeBytes } from 'ng-uikit-pro-standard';

@Component({
  selector: 'ngx-modal-upload-nf',
  templateUrl: './modal-upload-nf.component.html',
  styleUrls: ['./modal-upload-nf.component.scss']
})
export class ModalUploadNfComponent implements OnInit {

  @Input() id: string;
  @ViewChild("card", null)
  private card: ElementRef;


  @ViewChild("inputFileLabel", null)
  private inputFileLabel: ElementRef;

  public listTipo = null;
  public formModalUpload = null;
  public file: any;
  formData: FormData;

  humanizeBytes: Function;
  dragOver: boolean;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<ModalUploadNfComponent>,
    private service: ModalUploadNfService,
    private notificationsService: NotificationsService,
    private spinner: NgxSpinnerService,
  ) {

    this.listTipo = [

      {
        tipoArquivo: 'NF',
        descricao: 'NF'
      },

      {
        tipoArquivo: 'NFC',
        descricao: 'NFC'
      },

    ];


  }


  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    const el = this.card && this.card.nativeElement;
    if (el && el.ownerDocument && el.ownerDocument.activeElement && el.ownerDocument.activeElement.blur) {
      el.ownerDocument.activeElement.blur();
    }
    this.formModalUpload = this.formBuilder.group({
      pedidoVendaId: [this.id],
      tipoArquivo: [null],
      descricao: [null],
      arquivoNota: [null],

    });

  }

  saveOnUpload(data) {
    data.id = this.id;

    let tipoArquivo = data.tipoArquivo;
    let pedidoVendaId = data.pedidoVendaId;
    let descricao = data.descricao;
    let arquivoNota = data.arquivoNota;

    let params: any = {
      tipoArquivo: tipoArquivo,
      pedidoVendaId: pedidoVendaId,
      descricao: descricao
    }

    this.spinner.show();
    this.service.registerNfFile(arquivoNota, params).subscribe(resp => {
      this.spinner.hide();
      this.notificationsService.success('Upload de NF realizado com sucesso!');
    }, err => {
      this.spinner.hide();
      if(err.status >= 500) {
        this.notificationsService.error('Não foi possível realizar a operação. ' +
         'Entre em contato como o administrador do sistema');
      }else {
        this.notificationsService.error(err.error.message);
      }
    });

  }

  dismiss() {
    this.ref.close();
  }

  onUploadOutput(event): void {
    let reader = new FileReader();

    if(event.target.files && event.target.files.length) {
      let file = event.target.files[0];
      this.inputFileLabel.nativeElement.innerText = file.name;

      let formData = new FormData();
      formData.append('arquivoNota', file, file.name);

      reader.readAsDataURL(file);
      reader.onload = () => {
        this.formModalUpload.patchValue({
          arquivoNota: formData
        });

        // need to run CD since file load runs outside of zone
      };
    }
  }



  fecharForm(): void{
    this.ref.close();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
